import { PRELOADED_ACTIONS } from '../../actions/preloaded';

const initialState = {
  categories: [],
  articles: [],
  templates: [],
  automations: [],
  stats: [],
  authorisedRoles: [],
  settings: [],
  menuItems: [],
  datasources: [],
  apps: [],
  prompts: [],
  pages: [],
  public_pages: [],
  pageTemplates: []
};

const PreloadedReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'USER_LOGOUT' || 'INVALID_USER':
      return initialState;
    case PRELOADED_ACTIONS.THEMES_LOADED:
      const appThemeIndex = state.apps.findIndex(
        a => a.id === action.payload.appId
      );
      const newThemeApps = [...state.apps];
      newThemeApps[appThemeIndex].actions = action.payload.actions;
      return {
        ...state,
        apps: newThemeApps
      };
    case PRELOADED_ACTIONS.ACTIONS_LOADED:
      const appIndex = state.apps.findIndex(a => a.id === action.payload.appId);
      const newApps = [...state.apps];
      newApps[appIndex].actions = action.payload.actions;
      return {
        ...state,
        apps: newApps
      };
    case PRELOADED_ACTIONS.DATASOURCES_LOADED:
      const dsAppIndex = state.apps.findIndex(
        a => a.id === action.payload.appId
      );
      const newDsApps = [...state.apps];
      newDsApps[dsAppIndex].datasources = action.payload.datasources;
      return {
        ...state,
        apps: newDsApps
      };
    case PRELOADED_ACTIONS.APPS_LOADED:
      return {
        ...state,
        apps: action.payload
      };
    case PRELOADED_ACTIONS.PAGES_LOADED:
      return {
        ...state,
        pages: action.payload
      };
    case PRELOADED_ACTIONS.PAGE_TEMPLATES_LOADED:
      return {
        ...state,
        pageTemplates: action.payload
      };
    case PRELOADED_ACTIONS.PROMPTS_LOADED:
      return {
        ...state,
        prompts: action.payload
      };
    case PRELOADED_ACTIONS.MENU_ITEMS_LOADED:
      return {
        ...state,
        menuItems: action.payload
      };
    case PRELOADED_ACTIONS.SETTINGS_LOADED:
      return {
        ...state,
        settings: action.payload
      };
    case PRELOADED_ACTIONS.AUTHORISED_ROLES_LOADED:
      return {
        ...state,
        authorisedRoles: action.payload
      };
    case PRELOADED_ACTIONS.TEMPLATES_LOADED: {
      return {
        ...state,
        templates: action.payload
      };
    }
    case PRELOADED_ACTIONS.ARTICLES_LOADED: {
      return {
        ...state,
        articles: action.payload
      };
    }
    case PRELOADED_ACTIONS.CATEGORIES_LOADED: {
      return {
        ...state,
        categories: action.payload
      };
    }
    case PRELOADED_ACTIONS.AUTOMATIONS_LOADED: {
      return {
        ...state,
        automations: action.payload
      };
    }
    case PRELOADED_ACTIONS.STATS_LOADED: {
      return {
        ...state,
        stats: action.payload
      };
    }

    default:
      return state;
  }
};

export default PreloadedReducer;
